import { UseMutationOptions } from "@tanstack/react-query"

import { type ResponseConfig } from "~/backend/axiosClient"
import { queryClient } from "~/backend/queryClient"
import { UpdateMappingElementRequestDto } from "~/gen/api"
import {
  findMappingByTypeQueryKey,
  findPendingMappingQueryKey,
  useUpdateMappingElement,
} from "~/gen/api/hooks"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useUpdateMappingElementMutation = (
  queryParams: { page: number },
  options?: UseMutationOptions<
    ResponseConfig<boolean>,
    unknown,
    {
      data: UpdateMappingElementRequestDto
    }
  >
) =>
  useUpdateMappingElement({
    mutation: {
      ...options,
      onSuccess: async (_data, variables) => {
        await queryClient.invalidateQueries({
          queryKey: findMappingByTypeQueryKey(variables.data.type, queryParams),
        })
        await queryClient.invalidateQueries({
          queryKey: findPendingMappingQueryKey(),
        })
        showSuccessNotification({
          title: "Updated Mapping type",
          message: `Mapping has been updated successfully`,
        })
      },
    },
  })
